import { alpha, Button, Card, Paper, styled, Typography } from '@mui/material';

export const LoaderContainerStyled = styled('div')({
  width: '100%',
  height: '50vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const DesktopViewStyled = styled(Paper)({
  padding: 16,
  '@media(max-width: 750px)': {
    display: 'none',
  },
  border: '1px solid #707070',
});

export const HeaderContainerStyled = styled('div')({
  marginBottom: 16,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const BtnStyled = styled(Button)({
  width: 250,
  height: 42,
});

export const MobileDivStyled = styled('div')({
  position: 'relative',
  paddingBottom: 24,
  '@media(min-width: 751px)': {
    display: 'none',
  },
});

export const MobileTitleStyled = styled(Typography)({
  textAlign: 'center',
  fontSize: '16px',
  marginBottom: '28px',
});

export const CardPayableStyled = styled('div')(({ theme }) => ({
  padding: 20,
  display: 'flex',
  gap: 24,
  backgroundColor: alpha(theme.palette.secondary.main, 0.2),
  borderRadius: 16,
  margin: 12,
}));

export const BarsContainerStyled = styled('div')({
  display: 'flex',
  gap: 8,
  alignItems: 'flex-end',
});

export const PaidBarStyled = styled('div')({
  width: 25,
  backgroundColor: '#29D17D',
  borderRadius: 16,
});

export const PendingBarStyled = styled('div')({
  width: 25,
  backgroundColor: '#FF4A56',
  borderRadius: 16,
});

export const PayablesCardStyled = styled('div')({
  textDecoration: 'none',
  padding: '12px 0px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  '& .payment': {
    color: '#434242',
    fontWeight: 'normal',
    fontSize: 13,
    '& .paid': {
      color: '#29D17D',
    },
    '& .pending': {
      color: '#FF4A56',
    },
  },
});

export const FilterStyled = styled('div')(({ theme }) => ({
  margin: '1rem 1rem 24px 1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& button': {
    padding: '7px 16px',
    fontFamily: 'Montserrat',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '14px',
    color: theme.palette.global.white,
    background: theme.palette.secondary.main,
    border: 'none',
    outline: 'none',
    borderRadius: '4px',
  },
}));

export const PayablesCountStyled = styled(Typography)({
  fontSize: '14px',
  fontWeight: '100',
  lineHeight: '19px',
});

export const ListStyled = styled(Card)({
  margin: '1rem',
  padding: 8,
  '& + .MuiCard-root': {
    marginTop: '1rem',
  },
});

export const PayableListStyled = styled('div')(({ theme }) => ({
  height: 64,
  display: 'flex',
  justifyContent: 'space-between',
  '& .supplierName': {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: '50%',
    whiteSpace: 'nowrap',
  },
  '& .categoryName': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '90%',
    fontSize: '13px',
    lineHeight: '18px',
    color: theme.palette.secondary.main,
  },
  '& .pendingPayment': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 8,
  },
}));

export const SupplierNameStyled = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: '14px',
  fontWeight: '600',
  lineHeight: '19px',
});

export const PayableDueStyled = styled(Typography)({
  fontSize: '13px',
  fontWeight: 'normal',
  lineHeight: '18px',
});

export const PayableTotalStyled = styled(Typography)({
  fontSize: '14px',
  fontWeight: '500',
  textAlign: 'right',
});
